// extracted by mini-css-extract-plugin
module.exports = {"card":"map_card__uU5Pi","facility":"map_facility__vR__5"};